(function() {
  'use strict';

  var configElement = document.getElementById('bf-cart-price-guard-config');
  if (!configElement || window.BiofargoCartPriceGuard) return;
  var config = JSON.parse(configElement.textContent);
  var root = config.root.replace(/\/?$/, '/');
  var pending = false;
  var replayCheckout = false;
  var pendingMutations = 0;
  var idleCallbacks = [];

  function mutationFinished() {
    pendingMutations--;
    if (!pendingMutations) {
      idleCallbacks.splice(0).forEach(function(callback) { callback(); });
    }
  }

  function waitForMutations() {
    return pendingMutations ? new Promise(function(resolve) {
      idleCallbacks.push(resolve);
    }) : Promise.resolve();
  }

  function trackMutation(callback) {
    pendingMutations++;
    return Promise.resolve().then(callback).then(function(response) {
      mutationFinished();
      return response;
    }, function(error) {
      mutationFinished();
      throw error;
    });
  }

  function showError(message, items) {
    var notice = document.querySelector('.main-cart [data-bf-price-notice]');
    if (!notice) {
      window.alert(message + (items.length ? '\n\n' + items.join('\n') : ''));
      return;
    }
    notice.textContent = '';
    var text = document.createElement('p');
    text.textContent = message;
    notice.appendChild(text);
    if (items.length) {
      var list = document.createElement('ul');
      items.forEach(function(title) {
        var item = document.createElement('li');
        item.textContent = title;
        list.appendChild(item);
      });
      notice.appendChild(list);
    }
    notice.hidden = false;
    notice.focus();
    notice.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function validate() {
    // Liquid checks current prices and trusted metafields on Shopify. Do not
    // cache the result: cart contents and promotion approvals can change.
    var controller = new AbortController();
    var timeout = setTimeout(function() { controller.abort(); }, 15000);
    return fetch(root + 'cart?view=price-validation', {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' },
      signal: controller.signal
    }).then(function(response) {
      if (!response.ok) throw new Error('Price validation request failed');
      return response.text();
    }).then(function(body) {
      var result = JSON.parse(body);
      if (!Array.isArray(result.blockedItems) || !result.blockedItems.every(function(title) {
        return typeof title === 'string';
      })) throw new Error('Invalid price validation response');
      if (result.blockedItems.length) {
        showError(config.message, result.blockedItems);
        return false;
      }
      document.querySelectorAll('[data-bf-price-notice]').forEach(function(notice) {
        notice.textContent = '';
        notice.hidden = true;
      });
      return true;
    }).catch(function() {
      showError(config.error, []);
      return false;
    }).finally(function() {
      clearTimeout(timeout);
    });
  }

  function isCheckoutUrl(value) {
    if (!value) return false;
    var url = new URL(value, location.href);
    var pathname = url.pathname.replace(/\/$/, '');
    return url.origin === location.origin &&
      (pathname === '/checkout' || pathname === root + 'checkout');
  }

  function guard(event, control, resume) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    control.setAttribute('aria-busy', 'true');
    Promise.resolve().then(function() {
      var gift = window.BiofargoFreeTshirt;
      return gift && gift.prepareCheckout ? gift.prepareCheckout() : null;
    }).then(waitForMutations).then(validate).then(function(allowed) {
      if (!allowed) return;
      replayCheckout = true;
      try { resume(); } finally { replayCheckout = false; }
    }).catch(function() {
      showError(config.error, []);
    }).finally(function() {
      pending = false;
      control.removeAttribute('aria-busy');
    });
  }

  window.BiofargoCartPriceGuard = { validate: validate, trackMutation: trackMutation };

  if (window.jQuery) {
    var cartMutation = /\/cart\/(add|change|update|clear)\.js(?:\?|$)/;
    jQuery(document).on('ajaxSend.bfPriceGuard', function(event, xhr, options) {
      if (cartMutation.test(options.url)) {
        xhr.bfPriceMutation = true;
        pendingMutations++;
      }
    }).on('ajaxComplete.bfPriceGuard', function(event, xhr) {
      if (xhr.bfPriceMutation) mutationFinished();
    });
  }

  document.addEventListener('click', function(event) {
    if (replayCheckout) return;
    var link = event.target.closest('a[href]');
    if (link && isCheckoutUrl(link.getAttribute('data-bf-checkout-url') || link.href)) {
      guard(event, link, function() {
        var destination = link.getAttribute('data-bf-checkout-url');
        if (destination) link.href = destination;
        link.removeAttribute('aria-disabled');
        link.click();
      });
      return;
    }
    var button = event.target.closest('button, input');
    if (button && /^(checkout|goto_pp|goto_gc)$/.test(button.name)) {
      guard(event, button, function() { button.click(); });
    }
  }, true);

  document.addEventListener('submit', function(event) {
    if (replayCheckout) return;
    var form = event.target;
    var submitter = event.submitter;
    if (!isCheckoutUrl(form.action) &&
        !(submitter && /^(checkout|goto_pp|goto_gc)$/.test(submitter.name))) return;
    guard(event, form, function() {
      if (submitter) form.requestSubmit(submitter);
      else form.requestSubmit();
    });
  }, true);
})();
